import React from "react";

import { useModalContext } from "../../contexts/ModalContext/context";

import { Modal } from "../../components/Modal";
import { Typography } from "../../UI/Typography";
import { Box } from "../../UI/Box";
import { Button } from "../../UI/Button";

interface IProps {
  show: boolean;
  onClose: VoidFunction;
  onConfirm: VoidFunction;
}

export const CancelInvitationModal: React.FC<IProps> = (props) => {
  const { setIsOpen } = useModalContext();

  React.useEffect(() => {
    setIsOpen(props.show);
  }, [props.show]);

  return (
    <Modal
      maxWidth="sm"
      title="Confirm invitation Cancelation"
      actions={
        <>
          <Button onClick={props.onClose}>Cancel</Button>
          <Button appearance="primary" onClick={props.onConfirm}>
            Cancel Invitation
          </Button>
        </>
      }
    >
      <Box px={3} py={2}>
        <Typography gutterBottom>You are about to cancel this user's invitation.</Typography>
      </Box>
    </Modal>
  );
};
